import React from "react";
import PropTypes from "prop-types";

import Button from "ui/Button";

const ButtonGroup = ({handleClose, handleNewTicketSubmit, loading, disabled}) => {
  return (
    <>
        <Button secondary onClick={handleClose} fullwidth loading={loading}>
          Cancel
        </Button>
        <Button
          highlighted
          fullwidth
          onClick={handleNewTicketSubmit}
          loading={loading}
          disabled={disabled}
        >
          Complete Sale
        </Button>
    </>
)}

ButtonGroup.propTypes = {
  handleClose: PropTypes.func,
  handleNewTicketSubmit: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool
};

export default ButtonGroup;